import React from 'react';
import { Box } from '@mui/material';
import FamiliplusPointBox from './FamiliplusPointBox';
import { useTranslation } from 'react-i18next';

const FamiliplusBonusPoints = (): JSX.Element => {
  const { t } = useTranslation('component');
  return (
    <>
      <Box className="boxLightGray">
        <Box className="boxLightGrayContent">
          <Box className="boxLightGrayTitle" color={(theme) => theme.palette.error.main}>
            {t('FamiliplusBonusPoints.Title')}
          </Box>
          <Box className="boxLightGrayText">{t('FamiliplusBonusPoints.Description')}</Box>
        </Box>
        <FamiliplusPointBox points="25"></FamiliplusPointBox>
      </Box>
    </>
  );
};

export default FamiliplusBonusPoints;
